var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Material Design/Arrow Circle/White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Material-Design/Arrow-Circle/White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,5.89777195 L10,9.43643512 L15,4.71821756 L10,0 L10,3.53866317 C4.475,3.53866317 0,7.76146789 0,12.9750983 C0,14.8269987 0.575,16.5491481 1.55,18 L3.375,16.2778506 C2.8125,15.2988204 2.5,14.1664482 2.5,12.9750983 C2.5,9.07077326 5.8625,5.89777195 10,5.89777195 L10,5.89777195 Z M18.45,7 L16.625,8.72214941 C17.175,9.7129751 17.5,10.8335518 17.5,12.0249017 C17.5,15.9292267 14.1375,19.102228 10,19.102228 L10,15.5635649 L5,20.2817824 L10,25 L10,21.4613368 C15.525,21.4613368 20,17.2385321 20,12.0249017 C20,10.1730013 19.425,8.4508519 18.45,7 L18.45,7 Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerWhite);
export default __webpack_public_path__ + "static/media/spinner-white.80e5f2d098bc50dd1ff499b0b67ea4fa.svg";
export { ForwardRef as ReactComponent };